import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import apinode from '../../services/apinode';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import PdfReportButton from './curva_a';

export default function ProdutoDetalhes() {
  const { produtoId } = useParams();
  const [produto, setProduto] = useState(null);
  const [loading, setLoading] = useState(true);
  const [imagemSelecionada, setImagemSelecionada] = useState(null);

  useEffect(() => {
    const fetchProduto = async () => {
      try {
        const token = 'APP_USR-3348978167659605-080413-bc6855ad6734924003b6382d8f43097c-514066249';
        const res = await apinode.get(`/meli/api/produto/${produtoId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setProduto(res.data.dados);
        setImagemSelecionada(res.data.dados.midia.imagemPrincipal);
      } catch (err) {
        console.error('Erro ao buscar produto:', err);
      } finally {
        setLoading(false);
      }
    };

    if (produtoId) fetchProduto();
  }, [produtoId]);

  if (loading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
        <div className="text-center">
          <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
          <p className="mt-3 text-muted fs-5">Carregando produto...</p>
        </div>
      </div>
    );
  }

  if (!produto) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center">
        <div className="text-center">
          <div className="display-1 text-danger mb-3">⚠️</div>
          <h2 className="text-danger">Produto não encontrado</h2>
          <p className="text-muted">O produto solicitado não está disponível.</p>
        </div>
      </div>
    );
  }

  const precoFormatado = produto.precos.atual.toLocaleString('pt-BR', {
    style: 'currency',
    currency: produto.precos.moeda,
  });

  const parcelamento = produto.precos?.parcelamento?.toLocaleString('pt-BR', {
    style: 'currency',
    currency: produto.precos.moeda,
  });

  const health = produto.metadados.saude || 0;
  const healthPercent = Math.round(health * 100);
  const pieData = [
    { name: 'Saúde', value: healthPercent },
    { name: 'Problemas', value: 100 - healthPercent }
  ];
  const COLORS = ['#10b981', '#ef4444'];

  return (
    <div style={{
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      minHeight: '100vh',
      paddingTop: '2rem',
      paddingBottom: '2rem'
    }}>
      <div className="container">
        {/* Header Card */}
        <div className="card shadow-lg border-0 mb-4" style={{
          borderRadius: '20px',
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)'
        }}>
          <div className="card-body p-4">
            <div className="row align-items-center">
              <div className="col-lg-8">
                <div className="mb-3">
                  <span className="badge bg-primary rounded-pill px-3 py-2 mb-2">
                    ⭐ Produto Premium
                  </span>
                </div>
                <h1 className="display-6 fw-bold text-dark mb-3" style={{ lineHeight: '1.2' }}>
                  {produto.titulo}
                </h1>
                <div className="d-flex align-items-baseline gap-3 mb-3">
                  <span className="display-4 fw-bold text-success">{precoFormatado}</span>
                  {parcelamento && (
                    <span className="fs-5 text-muted">
                      ou 12x de <strong className="text-primary">{parcelamento}</strong>
                    </span>
                  )}
                </div>




                <div className="d-flex gap-4 text-muted">
                  <span className="d-flex align-items-center gap-2">
                    📦 <strong>Status:</strong> {produto.estoque.status}
                  </span>
                  <span className="d-flex align-items-center gap-2">
                    📊 <strong>Estoque:</strong> {produto.estoque.quantidadeDisponivel}
                  </span>
                </div>
              </div>
              <div className="col-lg-4 text-center">
                <div className="d-inline-block position-relative" style={{ width: 120, height: 120 }}>
                  <PieChart width={120} height={120}>
                    <Pie
                      data={pieData}
                      cx={60}
                      cy={60}
                      innerRadius={35}
                      outerRadius={50}
                      dataKey="value"
                      startAngle={90}
                      endAngle={450}
                    >
                      {pieData.map((entry, index) => (
                        <Cell key={index} fill={COLORS[index]} />
                      ))}
                    </Pie>
                  </PieChart>
                  <div className="position-absolute top-50 start-50 translate-middle d-flex flex-column align-items-center justify-content-center text-center">
                    <div className="fw-bold text-success" style={{ fontSize: '1rem', lineHeight: 1 }}>{healthPercent}%</div>
                    <small className="text-muted" style={{ fontSize: '0.6rem', lineHeight: 1 }}>Saúde</small>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="row g-4">
          {/* Galeria de Imagens */}
          <div className="col-lg-7">
            <div className="card shadow-lg border-0 h-100" style={{
              borderRadius: '20px',
              background: 'rgba(255, 255, 255, 0.95)',
              backdropFilter: 'blur(10px)'
            }}>
              <div className="card-body p-4">
                <div className="position-relative mb-4" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                  <img
                    src={imagemSelecionada}
                    alt={produto.titulo}
                    className="w-100"
                    style={{
                      height: '400px',
                      objectFit: 'contain',
                      background: 'linear-gradient(45deg, #f8f9fa, #e9ecef)'
                    }}
                  />
                  <div className="position-absolute top-0 end-0 m-3">
                    <span className="badge bg-dark bg-opacity-75 rounded-pill px-3 py-2">
                      🔍 HD
                    </span>
                  </div>
                </div>

                <div className="d-flex flex-wrap gap-2 justify-content-center">
                  {produto.midia.imagens.map((img) => (
                    <div key={img.id} className="text-center">
                      <div
                        className="position-relative"
                        style={{
                          borderRadius: '8px',
                          overflow: 'hidden',
                          cursor: 'pointer',
                          transform: imagemSelecionada === img.url ? 'scale(1.05)' : 'scale(1)',
                          transition: 'all 0.3s ease',
                          border: imagemSelecionada === img.url ? '2px solid #0d6efd' : '1px solid #e9ecef'
                        }}
                        onClick={() => setImagemSelecionada(img.url)}
                      >
                        <img
                          src={img.url}
                          alt=""
                          style={{
                            width: '50px',
                            height: '50px',
                            objectFit: 'cover'
                          }}
                        />
                        {imagemSelecionada === img.url && (
                          <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                            style={{ background: 'rgba(13, 110, 253, 0.2)' }}>
                            <span className="text-primary fs-6">✓</span>
                          </div>
                        )}
                      </div>
                      <small className="text-muted d-block mt-1" style={{ fontSize: '0.7rem' }}>{img.tamanho}</small>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Informações do Produto */}
          <div className="col-lg-5">
            <div className="d-flex flex-column gap-4">
              {/* Card de Informações Rápidas */}
              <div className="card shadow-lg border-0" style={{
                borderRadius: '20px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white'
              }}>
                <div className="card-body p-4">
                  <h5 className="card-title mb-3 d-flex align-items-center gap-2">
                    📈 <span>Informações de Venda</span>
                  </h5>
                  <div className="row g-3">
                    <div className="col-6 text-center">
                      <div className="fs-2 fw-bold">{produto.estoque.quantidadeDisponivel}</div>
                      <small className="opacity-75">Disponível</small>
                    </div>
                    <div className="col-6 text-center">
                      <div className="fs-2 fw-bold">{produto.estoque.quantidadeVendida}</div>
                      <small className="opacity-75">Vendidos</small>
                    </div>
                  </div>
                  <div className="mt-3 p-3 rounded" style={{ background: 'rgba(255, 255, 255, 0.1)' }}>
                    <div className="d-flex align-items-center gap-2">
                      🛡️ <strong>Garantia:</strong> {produto.garantia.tipo} - {produto.garantia.tempo}
                    </div>
                  </div>
                </div>
              </div>

              {/* Botão de Ação */}
              <a
                href={produto.permalink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-lg py-3 fw-bold text-decoration-none"
                style={{
                  background: 'linear-gradient(135deg, #ff6b6b 0%, #feca57 100%)',
                  color: 'white',
                  borderRadius: '15px',
                  border: 'none',
                  boxShadow: '0 8px 25px rgba(255, 107, 107, 0.3)',
                  transform: 'translateY(0)',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 12px 35px rgba(255, 107, 107, 0.4)';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 8px 25px rgba(255, 107, 107, 0.3)';
                }}
              >
                🛍️ Comprar no Mercado Livre
              </a>
            </div>
          </div>
        </div>

        {/* Seções de Conteúdo */}
        <div className="row g-4 mt-4">
          {/* Descrição */}
          <div className="col-lg-12">
            <div className="card shadow-lg border-0" style={{
              borderRadius: '20px',
              background: 'rgba(255, 255, 255, 0.95)',
              backdropFilter: 'blur(10px)'
            }}>
              <div className="card-body p-4">
                <h4 className="card-title mb-4 d-flex align-items-center gap-2">
                  📝 <span>Descrição do Produto</span>
                </h4>
                <div className="fs-6 text-muted" style={{
                  whiteSpace: 'pre-line',
                  lineHeight: '1.7',
                  background: '#f8f9fa',
                  padding: '20px',
                  borderRadius: '12px',
                  border: '1px solid #e9ecef'
                }}>
                  {produto.descricao}
                </div>
              </div>
            </div>
          </div>

          {/* Especificações */}
          <div className="col-lg-6">
            <div className="card shadow-lg border-0 h-100" style={{
              borderRadius: '20px',
              background: 'rgba(255, 255, 255, 0.95)',
              backdropFilter: 'blur(10px)'
            }}>
              <div className="card-body p-4">
                <h4 className="card-title mb-4 d-flex align-items-center gap-2">
                  🔍 <span>Especificações Técnicas</span>
                </h4>
                <div className="row g-2">
                  {Object.entries(produto.especificacoes).map(([chave, valor]) => (
                    <div key={chave} className="col-12">
                      <div className="p-3 rounded-3" style={{
                        background: 'linear-gradient(90deg, #f8f9fa 0%, #e9ecef 100%)',
                        border: '1px solid #dee2e6'
                      }}>
                        <div className="d-flex justify-content-between align-items-center">
                          <strong className="text-primary">{chave}</strong>
                          <span className="text-dark">
                            {Array.isArray(valor.valor) ? valor.valor.join(', ') : valor.valor}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Variações */}
          <div className="col-lg-6">
            <div className="card shadow-lg border-0 h-100" style={{
              borderRadius: '20px',
              background: 'rgba(255, 255, 255, 0.95)',
              backdropFilter: 'blur(10px)'
            }}>
              <div className="card-body p-4">
                <h4 className="card-title mb-4 d-flex align-items-center gap-2">
                  🎛️ <span>Variações Disponíveis</span>
                </h4>
                <div className="row g-3">
                  {produto.variacoes.disponiveis.slice(0, 4).map((v) => (
                    <div key={v.id} className="col-12">
                      <div className="p-3 rounded-3 h-100" style={{
                        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                        border: '1px solid #dee2e6',
                        transition: 'all 0.3s ease'
                      }}>
                        <div className="row align-items-center">
                          <div className="col-3">
                            <img
                              src={`https://http2.mlstatic.com/D_${v.imagens[0]}-O.jpg`}
                              alt=""
                              className="w-100 rounded"
                              style={{ height: '60px', objectFit: 'contain' }}
                            />
                          </div>
                          <div className="col-9">
                            <div className="small">
                              {Object.entries(v.atributos).map(([nome, attr]) => (
                                <div key={nome} className="mb-1">
                                  <strong>{nome}:</strong> <span className="text-primary">{attr.valor}</span>
                                </div>
                              ))}
                              <div className="d-flex gap-3 mt-2">
                                <span className="badge bg-success">📦 {v.estoque.disponivel}</span>
                                <span className="badge bg-info">📈 {v.estoque.vendidos}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Alertas de Validação */}
        {produto.validacao?.erros?.length > 0 && (
          <div className="mt-4">
            <div className="card shadow-lg border-0" style={{
              borderRadius: '20px',
              background: 'linear-gradient(135deg, #ff6b6b 0%, #feca57 100%)',
              color: 'white'
            }}>
              <div className="card-body p-4">
                <h5 className="card-title mb-3 d-flex align-items-center gap-2">
                  ⚠️ <span>Problemas Identificados</span>
                </h5>
                <div className="row g-2">
                  {produto.validacao.erros.map((erro, i) => (
                    <div key={i} className="col-12">
                      <div className="p-2 rounded" style={{ background: 'rgba(255, 255, 255, 0.1)' }}>
                        ❌ {erro}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}